import { Box, Typography } from '@mui/material';

import Icons from '../../themes/icons';

export const ViolationMessage: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#F5F5F5',
        borderBottom: '1px solid #E6E6E6',
        padding: '10px 20px',
        color: '#5C5E95',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <Icons.SecureIcon style={{ width: 16, height: 16, flexShrink: 0 }} />
      <Typography fontSize={'13px'} fontFamily={'Poppins'} fontWeight={'400'} color={'#111'}>
        <Typography
          fontSize={'13px'}
          fontWeight={'400'}
          component={'span'}
          color={'#111'}
          fontFamily={'Poppins'}
        >
          Do not make deals outside the app.
        </Typography>{' '}
        This ensures secure transactions and protects your account. Violations may result in account
        suspension.
      </Typography>
    </Box>
  );
};
